var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-item",
    {
      key: _vm.enrollment.id,
      staticClass: "d-flex align-stretch",
      attrs: { cytag: "course-item" },
      on: { click: _vm.saveNavigationPath },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-center py-6 pe-3" },
        [
          _c("v-img", {
            attrs: {
              width: _vm.size,
              height: _vm.size,
              src: _vm.enrollment.course.image.url,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex flex-column justify-space-between py-5",
          style: "width: calc(100% - " + _vm.size + "px",
        },
        [
          _c(
            "div",
            [
              _c("div", [
                _c("span", [
                  _vm._v(" " + _vm._s(_vm.enrollment.course.name) + " "),
                ]),
              ]),
              _vm._v(" "),
              _c("v-list-item-subtitle", {
                domProps: {
                  innerHTML: _vm._s(_vm.enrollment.course.description),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mt-2",
              style: { width: _vm.isMobile ? "100%" : "40%" },
            },
            [
              _c(
                "v-progress-linear",
                {
                  attrs: {
                    value: _vm.enrollment.progressPercent,
                    height: "15",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.enrollment.progressPercent) +
                      "%\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }